function m(e, t, i) {
  const {
    focusElCls: n,
    focus: o,
    borderElCls: c
  } = i, s = c ? "> *" : "", r = ["hover", o ? "focus" : null, "active"].filter(Boolean).map((a) => `&:${a} ${s}`).join(",");
  return {
    [`&-item:not(${t}-last-item)`]: {
      marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [r]: {
        zIndex: 2
      }
    }, n ? {
      [`&${n}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${s}`]: {
        zIndex: 0
      }
    })
  };
}
function d(e, t, i) {
  const {
    borderElCls: n
  } = i, o = n ? `> ${n}` : "";
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item) ${o}`]: {
      borderRadius: 0
    },
    [`&-item:not(${t}-last-item)${t}-first-item`]: {
      [`& ${o}, &${e}-sm ${o}, &${e}-lg ${o}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${t}-first-item)${t}-last-item`]: {
      [`& ${o}, &${e}-sm ${o}, &${e}-lg ${o}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function u(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: i
  } = e, n = `${i}-compact`;
  return {
    [n]: Object.assign(Object.assign({}, m(e, n, t)), d(i, n, t))
  };
}
export {
  u as g
};
//# sourceMappingURL=compact-item-DH13cl8A.mjs.map
